import type { CustomTextContent } from '@/blocks/domain/types/BlockContent/ProseContent';
import { fromProseContent, mapProseContent, type ProseContentDtoFor } from '@/blocks/application/mappers/blockProseMapper';

export function mapCustomTextContent(dto: ProseContentDtoFor<'custom_text'>): CustomTextContent {
  return mapProseContent(dto) as CustomTextContent;
}

export function fromCustomTextContent(content: CustomTextContent): ProseContentDtoFor<'custom_text'> {
  return fromProseContent(content) as ProseContentDtoFor<'custom_text'>;
}
